import { useCommentsScopeStore } from "./useCommentsScopeStore";
import { useDashboardFiltersStore } from "./useDashboardFiltersStore";
import { useProjectFiltersStore } from "./useProjectFiltersStore";
import { useInvestorDocumentFiltersStore } from "./useInvestorDocumentFiltersStore";

/**
 * Resets org-scoped filter and view stores during organization switching.
 *
 * Excluded by design:
 * - Main listings (investments, investors, beneficiaries, contracts) keep their
 *   filters + pagination in the URL, not Zustand — the org switch hook drops the
 *   query string instead (useSwitchOrganization.onSuccess).
 * - useInvestmentViewModeStore — kanban/table/list is a UI preference, not data
 *
 * When adding or removing an org-scoped filter store, update this function.
 */
export const resetAllFilterStores = () => {
  useCommentsScopeStore.getState().reset();
  useDashboardFiltersStore.getState().reset();
  useProjectFiltersStore.getState().reset();
  useInvestorDocumentFiltersStore.getState().reset();
};
